import React, { useState, useEffect } from 'react';
import { API_URL } from '../config/api';
import CourseQuestionList from './CourseQuestionList';
import './CourseDetail.css';

const CourseDetail = ({ course, onBack }) => {
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [selectedSection, setSelectedSection] = useState(null);
    const [showQuestions, setShowQuestions] = useState(false);

    useEffect(() => {
        if (course && course.id) {
            fetchSections();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [course.id]);

    const fetchSections = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${API_URL}/api/course-sections/course/${course.id}`, {
                credentials: 'include'
            });
            
            if (response.ok) {
                const sectionsData = await response.json();
                setSections(sectionsData.sort((a, b) => (a.sectionOrder || 0) - (b.sectionOrder || 0)));
            } else {
                setError('Failed to fetch sections');
            }
        } catch (error) {
            console.error('Error fetching sections:', error);
            setError('Network error while fetching sections');
        } finally {
            setLoading(false);
        }
    };

    const handleViewQuestions = (section) => {
        setSelectedSection(section);
        setShowQuestions(true);
    };

    const handleBackToSections = () => {
        setShowQuestions(false);
        setSelectedSection(null);
    };

    if (showQuestions && selectedSection) {
        return (
            <div className="course-detail">
                <div className="course-detail-header">
                    <button 
                        type="button" 
                        className="back-btn"
                        onClick={handleBackToSections}
                    >
                        ← Back to Sections
                    </button>
                    <h2>Questions: {selectedSection.title}</h2>
                </div>
                <CourseQuestionList 
                    sectionId={selectedSection.id}
                    sectionTitle={selectedSection.title}
                />
            </div>
        );
    }

    return (
        <div className="course-detail">
            <div className="course-detail-header">
                <button 
                    type="button" 
                    className="back-btn"
                    onClick={onBack}
                >
                    ← Back to Courses
                </button>
                <h2>{course.title}</h2>
            </div>

            <div className="course-info">
                <div className="course-meta">
                    <p><strong>Instructor:</strong> {course.instructor}</p>
                    <p><strong>Category:</strong> {course.category}</p>
                    <p><strong>Price:</strong> ₹{course.price}</p>
                    {course.durationHours && (
                        <p><strong>Duration:</strong> {course.durationHours} hours</p>
                    )}
                </div>
                
                <div className="course-description">
                    <h3>Description</h3>
                    <p>{course.description}</p>
                </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <div className="sections-section">
                <h3>Course Sections ({sections.length})</h3>
                
                {loading ? (
                    <div className="loading">Loading sections...</div>
                ) : sections.length === 0 ? (
                    <div className="no-sections">
                        <p>No sections available for this course.</p>
                    </div>
                ) : (
                    <div className="sections-list">
                        {sections.map((section, index) => (
                            <div key={section.id} className="section-card">
                                <div className="section-header">
                                    <div className="section-number">{index + 1}</div>
                                    <div className="section-info">
                                        <h4>{section.title}</h4>
                                        <p>{section.description}</p>
                                        <div className="section-meta">
                                            <span className="section-order">Order: {section.sectionOrder}</span>
                                            {section.isFree && <span className="free-badge">Free</span>}
                                            
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="section-actions">
                                    <button 
                                        className="view-questions-btn"
                                        onClick={() => handleViewQuestions(section)}
                                    >
                                        View Questions
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CourseDetail; 
